import { render, staticRenderFns } from "./warning-circle.vue?vue&type=template&id=4950f7d1&"
import script from "./warning-circle.vue?vue&type=script&lang=js&"
export * from "./warning-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4950f7d1')) {
      api.createRecord('4950f7d1', component.options)
    } else {
      api.reload('4950f7d1', component.options)
    }
    module.hot.accept("./warning-circle.vue?vue&type=template&id=4950f7d1&", function () {
      api.rerender('4950f7d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/warning-circle.vue"
export default component.exports